function TodoError(params) {
    return <h2>Error to load data</h2>
}

export { TodoError }
